import { Permissions } from '@/common/enums/Permissions';
import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

interface IPermissions {
	[key: string]: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	authStatus$ = new BehaviorSubject<boolean>(false);

	readonly permissionsByCode = signal<IPermissions>({});

	private readonly rights$ = new BehaviorSubject<string[]>(this.rightsGet());

	private readonly destroyRef = inject(DestroyRef);

	constructor() {
		this.rights$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((rights) => {
			const permissions: IPermissions = {};
			for (const permission in Permissions) {
				const code = Permissions[permission];
				permissions[code] = rights.includes(code);
			}
			this.permissionsByCode.set(permissions);
		});
	}

	getUserId(): string {
		return localStorage.userId;
	}

	token2Set(token: string): void {
		localStorage.setItem('token2', token);
	}

	token2Get(): string {
		return (
			'OAuth ' +
			JSON.stringify({
				token: localStorage.token2,
				userId: localStorage.userId,
				rights: localStorage.rights,
			})
		);
	}

	userIdSet(userId: string): void {
		localStorage.setItem('userId', userId);
	}

	rightsSet(rights: string[]): void {
		this.rights$.next(rights);
		localStorage.setItem('rights', JSON.stringify(this.rights$.getValue()));
	}

	rightsGet(): string[] {
		if (typeof localStorage.rights === 'undefined' || localStorage.rights == 'undefined') {
			return [];
		}
		return JSON.parse(localStorage.rights);
	}

	unauth(): void {
		this.token2Set('');
		this.authReload();
	}

	authReload(): void {
		this.authStatus$.next(this.isAuthenticated());
	}

	check(): void {
		this.authReload();
	}

	private isAuthenticated(): boolean {
		if (typeof localStorage.token === 'undefined' || localStorage.token == 'undefined') {
			return false;
		}
		if (!localStorage.token) {
			return false;
		}
		return true;
	}
}
